import { setHotVRGames, setNewVRGames } from '#BASE/common/gameTag.js';

setHotVRGames([
    'VR_1', //VR金星1.5分彩
    'VR_34', //VR水星分分彩
    'VR_11', //VR3分彩
]);

setNewVRGames([
    'VR_146', //香港日日六合彩
]);

export * from '#BASE/common/gameTag.js';